var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "PrinterConfig",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    name: _vm.formName,
                    readonly: _vm.resource.locked,
                    labelAlign: _vm.$config.forms.defaultLabelAlign,
                    id: _vm.formId
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpRow",
                    [
                      _c(
                        "ItpCol",
                        [
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "uri",
                                label: _vm.config.uri.label,
                                helpTooltip: _vm.config.uri.help,
                                required: _vm.config.uri.required
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  name: "uri",
                                  required: _vm.config.uri.required
                                },
                                model: {
                                  value: _vm.editor.uri,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "uri", $$v)
                                  },
                                  expression: "editor.uri"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "proxy",
                                label: _vm.config.proxy.label,
                                helpTooltip: _vm.config.proxy.help,
                                required: _vm.config.proxy.required
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  name: "proxy",
                                  required: _vm.config.proxy.required
                                },
                                model: {
                                  value: _vm.editor.proxy,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "proxy", $$v)
                                  },
                                  expression: "editor.proxy"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "name",
                                label: _vm.config.name.label,
                                helpTooltip: _vm.config.name.help,
                                required: _vm.config.name.required
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  name: "name",
                                  required: _vm.config.name.required
                                },
                                model: {
                                  value: _vm.editor.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "name", $$v)
                                  },
                                  expression: "editor.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "ipp_user_name",
                                label: _vm.config.ipp_user_name.label,
                                helpTooltip: _vm.config.ipp_user_name.help,
                                required: _vm.config.ipp_user_name.required
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: {
                                  name: "ipp_user_name",
                                  required: _vm.config.ipp_user_name.required
                                },
                                model: {
                                  value: _vm.editor.ipp_user_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "ipp_user_name", $$v)
                                  },
                                  expression: "editor.ipp_user_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "2",
                                name: "ipp_version",
                                label: _vm.config.ipp_version.label,
                                helpTooltip: _vm.config.ipp_version.help,
                                required: _vm.config.ipp_version.required
                              }
                            },
                            [
                              _c("ItpFormSelect", {
                                attrs: {
                                  name: "ipp_version",
                                  options: _vm.IPPVersions,
                                  required: _vm.config.ipp_version.required
                                },
                                model: {
                                  value: _vm.editor.ipp_version,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "ipp_version", $$v)
                                  },
                                  expression: "editor.ipp_version"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "is_default",
                                label: _vm.config.is_default.label,
                                helpTooltip: _vm.config.is_default.help
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "is_default" },
                                model: {
                                  value: _vm.editor.is_default,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "is_default", $$v)
                                  },
                                  expression: "editor.is_default"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.resource.isNew ? _c("hr") : _vm._e(),
              _vm._v(" "),
              !_vm.resource.isNew
                ? _c("PrinterTester", { attrs: { printerId: _vm.resource.id } })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              !_vm.resource.isNew
                ? _c("ItpButton", {
                    staticClass: "mr-auto",
                    attrs: {
                      text: _vm._f("pgettext")("Delete", "Button"),
                      variant: "danger",
                      icon: "fa-times",
                      spinning: _vm.actions.delete.isRunning
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_1548630417156826_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  form: _vm.forms[_vm.formName] && _vm.forms[_vm.formName].id,
                  text: _vm._f("pgettext")("Save", "Button"),
                  type: "submit",
                  variant: "primary",
                  default: "",
                  spinning: _vm.actions.submit && _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Close", "Button"),
                  variant: "default",
                  disabled: _vm.actions.submit && _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_2186679009640457_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }